var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6179 15.6C28.6179 19.463 26.9882 23.0554 24.3429 26.7294C22.1096 29.831 19.2516 32.863 16.2082 36.0918C15.9841 36.3295 15.759 36.5683 15.5331 36.8083C15.3071 36.5683 15.0821 36.3295 14.858 36.0918C11.8145 32.863 8.95656 29.831 6.7233 26.7294C4.078 23.0554 2.44824 19.463 2.44824 15.6C2.44824 7.71612 8.4 1.5 15.5331 1.5C22.6662 1.5 28.6179 7.71612 28.6179 15.6Z",
    stroke: "#188AEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0469 17C16.3894 17 17.4777 15.8807 17.4777 14.5C17.4777 13.1193 16.3894 12 15.0469 12C13.7044 12 12.6161 13.1193 12.6161 14.5C12.6161 15.8807 13.7044 17 15.0469 17Z",
    stroke: "#188AEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/locationBlue.1570e99200d15728fbb589160e496bd0.svg";
export { ForwardRef as ReactComponent };